<template>
  <van-dialog v-model="visible" :show-confirm-button="false" width="100vw" :closeOnClickOverlay="true">

    <div class="content1" v-show="showView==1">
      <p class="title">
        <span class="fw_bold">预留手机号：</span>
        方便下次登录查询；登录路径为：微信关注“多比利家”公众号，点击“多比商城”—“订单查询”。
      </p>
      <p class="title">
        <span class="fw_bold">不预留：</span>
        后期无法自主查询，只能联系销售人员。
      </p>
      <van-form ref="myform" @submit="onSubmit" label-width="0" :show-error-message="false">
        <van-field v-model="formData.mobile" name="mobile" type="tel" clearable placeholder="请输入正确的手机号" :rules="[{ validator:checkMobile, message: '请输入正确手机号' }]" />

        <van-field v-model="formData.verCode" name="verCode" center clearable placeholder="请输入短信验证码" :rules="[{ required:true, message: '请输入短信验证码' }]">
          <template #button>
            <van-button size="small" type="primary" :disabled="downTime > 0" native-type="button" @click="sendCode">{{
                  downTime > 0 ? downTime + "秒后重发" : "发送验证码"
                }}</van-button>
          </template>
        </van-field>

        <div class="btn">
          <van-button type="danger" native-type="submit" :loading="loading">确认预留</van-button>
          <van-button type="info" native-type="button" @click="showView=3">不预留</van-button>
        </div>
      </van-form>
    </div>

    <div class="content2" v-show="showView==2">
      <p class="title">尊欧的{{consignee}}客户：</p>
      <p class="title t28">您好！你可以微信关注“多比利家”公众号，随时查询您今日确认的订单。查询路径：点击“多比商城”—“订单查询”，输入手机验证后，即可查到。</p>
    </div>

    <div class="content2" v-show="showView==3">
      <p class="title fw_bold">温馨提醒：</p>
      <p class="title t28">确认不预留手机号吗？如果不预留手机号，后期将无法自主查询，只能联系销售人员截图。</p>
      <div class="btn">
        <van-button type="danger" native-type="button" @click="showView=1">去预留手机号</van-button>
        <van-button type="info" native-type="button" @click="visible=false">不预留</van-button>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import {
  SaveCustomerMobile,
  GetLoginVerCode,
} from "@/pages/page1/api-work/index";
import { Dialog, Form, Field, Button } from "vant";
import { validMobile } from "@/pages/publicUtils/validate";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      visible: false,
      showView: 1,
      formData: {
        mobile: undefined,
        verCode: undefined,
        orderSign: undefined,
      },
      loading: false,
      downTime: 0,
      consignee: "XXX",
    };
  },
  methods: {
    show(val, consignee) {
      this.visible = true;

      this.$nextTick(() => {
        this.resetForm(); //重置
        this.formData.orderSign = val;
        this.consignee = consignee;
        this.showView = 1;
      });
    },
    resetForm() {
      this.formData = {
        mobile: undefined,
        verCode: undefined,
        orderSign: undefined,
      };
      this.$refs.myform.resetValidation();
    },
    sendCode() {
      this.$refs.myform.validate("mobile").then(() => {
        GetLoginVerCode({ mobile: this.formData.mobile }).then((res) => {
          // console.log("获取到的验证码", res);
          this.formData.verCode = res.data[0].verCode;
          this.downTime = 60;
          let aTime = setInterval(() => {
            this.downTime -= 1;
            if (this.downTime <= 0) {
              clearInterval(aTime);
            }
          }, 1000);
        });
      });
    },
    onSubmit() {
      this.loading = true;
      SaveCustomerMobile(this.formData)
        .then((res) => {
          this.loading = false;
          this.showView = 2;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 验证
    checkMobile(val) {
      return validMobile(val);
    },
  },
};
</script>

<style lang="less" scoped>
.van-dialog {
  top: 60%;
  border-radius: 0;
  /deep/ .van-dialog__content {
    height: 7rem;
    overflow: hidden;
    padding: 0 0.3rem;
    line-height: 22px;
    font-size: 14px;
    .title {
      color: #ff0000;
    }
    .content1 {
      padding: 0.6rem 0 0;
      .van-form {
        margin: 0 0.6rem;
        .van-cell {
          border: 1px solid rgb(215, 215, 215);
          margin-top: 20px;
          padding: 0 16px;
          line-height: 32px;
          .van-field__button {
            position: relative;
            left: 16px;
            top: -4px;
            height: 32px;
            .van-button {
              background: @themeColor;
              border: 1px solid @themeColor;
            }
          }
        }
      }
    }
    .content2 {
      padding-top: 1rem;
      .t28 {
        text-indent: 28px;
      }
    }
    .btn {
      margin-top: 0.5rem;
      text-align: center;
      .van-button {
        height: 36px;
        background: rgb(217, 0, 27);
        min-width: 100px;
      }
      .van-button + .van-button {
        margin-left: 0.5rem;
        background: rgb(215, 215, 215);
        border-color: rgb(215, 215, 215);
        color: #666666;
      }
    }
  }
}
.fw_bold {
  font-weight: bold;
}
</style>